import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Button as s } from "../../forms/button/index.js";
import '../../../assets/verify.css';const v = "_verify_k4ul2_1", i = {
  verify: v,
  "verify--info": "_verify--info_k4ul2_10",
  "verify--info--title": "_verify--info--title_k4ul2_14",
  "verify--info--paragraph": "_verify--info--paragraph_k4ul2_16",
  "verify--info--actions": "_verify--info--actions_k4ul2_18",
  "verify--info--actions--button__advisor": "_verify--info--actions--button__advisor_k4ul2_27",
  "verify--figure": "_verify--figure_k4ul2_30",
  "verify--figure--img": "_verify--figure--img_k4ul2_37",
  "verify-clients": "_verify-clients_k4ul2_41"
}, m = ({
  titleText: r = "Hemos logrado que miles de transacciones inmobiliarias fueran más rápidas y seguras",
  paragraphText: n = "Cientos de usuarios de todos los tamaños han encontrado en nuestros informes el respaldo necesario para realizar operaciones inmobiliarias con confianza.",
  startVerificationButtonText: o = "Comenzar verificación",
  onClickStartVerificationButton: f = () => {
  },
  requestAdviserButtonText: l = "Consultar a nuestros asesores",
  onClickRequestAdviserButton: t = () => {
  },
  imageSource: c
}) => /* @__PURE__ */ a("section", { className: `${i.verify}`, children: [
  /* @__PURE__ */ a("article", { className: `${i["verify--info"]}`, children: [
    /* @__PURE__ */ e("h1", { className: `${i["verify--info--title"]} b-mb-7`, children: r }),
    /* @__PURE__ */ e("p", { className: `${i["verify--info--paragraph"]} b-mb-7`, children: n }),
    /* @__PURE__ */ a("div", { className: `${i["verify--info--actions"]}`, children: [
      /* @__PURE__ */ e(
        s,
        {
          onClick: f,
          className: "b-text-nowrap md:b-max-w-52",
          children: o
        }
      ),
      /* @__PURE__ */ e(
        s,
        {
          styleType: "link",
          className: `${i["verify--info--actions--button__advisor"]}`,
          onClick: t,
          children: l
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ e("figure", { className: `${i["verify--figure"]}`, children: /* @__PURE__ */ e(
    "img",
    {
      className: `${i["verify--figure--img"]}`,
      src: c,
      alt: "Propiedad certificada"
    }
  ) })
] }), u = ({
  children: r
}) => /* @__PURE__ */ e("div", { className: `${i["verify-clients"]}`, children: r });
export {
  u as ClientsVerifySection,
  m as default
};
